import { FetchRequest } from "./fetchRequest";

class Filter {
  async loadFilters() {
    return await FetchRequest({
      url: `/ssp/sendings/filters`,
      method: "GET",
      useToken: true,
    });
  }
}

const filterInstance = new Filter();

export default filterInstance;